
define('ldsh!modules/editor/templates/elements/video_amp', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<script async custom-element="amp-youtube" src="https://cdn.ampproject.org/v0/amp-youtube-0.1.js"></script>\n<amp-youtube\n    data-videoid="' +
((__t = ( videoID )) == null ? '' : __t) +
'"\n    layout="responsive"\n    width="480" height="270">\n    <div fallback>\n        <p data-i18n="editor.video.notSupport"></p>\n    </div>\n</amp-youtube>\n';

}
return __p
};});

